import BaseView from '../base-view';
import Suggest from '../components/suggest/index';

export default BaseView.extend({
	events: {
		'click [type="reset"]': 'onFormReset'
	},

	initialize: function() {
		this.createFilters();
	},

	/**
	 * create filters for the list
	 **/
	createFilters: function() {
		this.participantSuggestView = new Suggest.Views.Main({
			el: '.js-participant',
			dataUrl: '/extranet/autocompleteparticipant'
		}).render();
	},

	/**
	 * resets form and submits it
	 **/
	onFormReset: function(e) {
		// get form
		var form = e.currentTarget.form;

		// clear participant suggest view
		this.participantSuggestView.clear();

		// reset and submit form
		form.reset();
		form.submit();
	},

	render: function(msg) {
		return this;
	}
});
